export const ROUTES = {
  '/onboarding': '/onboarding',

  '/login': '/login',
  '/esqueci-a-senha': '/esqueci-a-senha',
  '/esqueci-a-senha/:token': '/esqueci-a-senha/:token',
  '/cadastro': '/cadastro',
  '/convidado/:invitation': '/convidado/:invitation',
  '/configuracoes/usuarios': '/configuracoes/usuarios',
  '/configuracoes/permissoes': '/configuracoes/permissoes',
  '/clientes': '/clientes',
  '/checklist': '/checklist',
  '/certificados': '/certificados',
  '/lembretes': '/lembretes',
  '/convencoes': '/convencoes',
  '/societario': '/societario',
  '/configuracoes': '/configuracoes',
  '/marketing/campanhas': '/marketing/campanhas',
  '/tarefas': '/tarefas',
  '/conferencia': '/conferencia',
  '/solicitacoes': '/solicitacoes',
  '/documentos': '/documentos',
  '/calendario/:id/:department': '/calendario/:id/:department',
  '/financeiro/painel': '/financeiro/painel',
  '/financeiro/extras': '/financeiro/extras',
  '/financeiro/mensalidades': '/financeiro/mensalidades',
  '/financeiro/comissoes': '/financeiro/comissoes',
  '/financeiro/conciliacao': '/financeiro/conciliacao',
  '/financeiro/contas-a-pagar': '/financeiro/contas-a-pagar',
  '/crm/leads': '/crm/leads',
  '/crm/social-selling': '/crm/social-selling',
  '/recuperacao-tributaria': '/recuperacao-tributaria',
  '/crm/prospeccao': '/crm/prospeccao',
  '/crm/prospeccao/table': '/crm/prospeccao/table',
  '/v2/leads/inss_obra': '/v2/leads/inss_obra',
  '/links': '/links',
  '/IRPF': '/IRPF',
  '/malha-fina/:department': '/malha-fina/:department',
  '/dividas-tributarias': '/dividas-tributarias',
  '/relatorios/inadimplentes': '/relatorios/inadimplentes',
  '/relatorios/prazos': '/relatorios/prazos',
  '/relatorios/honorarios': '/relatorios/honorarios',
  '/relatorios/emails': '/relatorios/emails',
  '/relatorios/emails/erros': '/relatorios/emails/erros',
  '/relatorios/kpis': '/relatorios/kpis',
  '/relatorios/socios': '/relatorios/socios',
  '/leads/forms/:id': '/leads/forms/:id',
  '/f/:token': '/f/:token',
  '/i/:id/:indicated_by_id?': '/i/:id/:indicated_by_id?',
  '/boards': '/boards',
  '/plugins': '/plugins',
  '/plugins/forms': '/plugins/forms',
  '/base-de-conhecimento': '/base-de-conhecimento',
  '/sair': '/sair',
  '/': '/'
}